import HeroMinimal from './components/HeroMinimal';
import PricingTable from './components/PricingTable';
import VideoTestimonials from './components/VideoTestimonials';
import { Footer } from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <HeroMinimal />
      <PricingTable />
      <VideoTestimonials />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
